const contact_logos = [
  {
    name: "Linkedin",
    logo: "Linkedin_logo.webp",
    href: "https://www.linkedin.com/in/fabienlpt/",
  },
  {
    name: "Github",
    logo: "Github_logo.webp",
    href: "https://github.com/fabienlpt/",
  },
];

export default contact_logos;
